export const amplifyconfig = {
  region: "eu-west-1",
  userPoolId: "eu-west-1_H2gldyuKy",
  userPoolWebClientId: "3ol6nssnc2qtq53t82s0pf9gpa",
  authenticationFlowType: "CUSTOM_AUTH"
};
